import script from "./FormularioProducto.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormularioProducto.vue?vue&type=script&setup=true&lang=ts"

import "./FormularioProducto.vue?vue&type=style&index=0&id=1d023122&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d023122"]])

export default __exports__